import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { ThemesVM } from './themes.viewmodel';

const ThemesContext = React.createContext<ThemesVM>(null);
const connectThemesVM = makeConnect(ThemesContext);

export { ThemesContext, connectThemesVM };
